(function(){
  function init(root){
    if(root.dataset.alcShopReady==='1')return;
    root.dataset.alcShopReady='1';
    // Position native Shopify filter choices inside the phone viewport and close on outside taps.
    const filterDetails=Array.from(root.querySelectorAll('.alc-shop__filter'));
    function positionFilter(detail){
      const menu=detail.querySelector('.alc-shop__filter-menu');
      const trigger=detail.querySelector('summary');
      if(!menu||!trigger||window.innerWidth>680)return;
      const rect=trigger.getBoundingClientRect();
      const width=Math.min(300,window.innerWidth-24);
      const height=Math.min(menu.scrollHeight,window.innerHeight*0.6,360);
      let top=rect.bottom+5;
      if(top+height>window.innerHeight-12)top=rect.top-height-5;
      menu.style.top=Math.max(12,Math.min(top,window.innerHeight-height-12))+'px';
      menu.style.left=Math.max(12,Math.min(rect.left,window.innerWidth-width-12))+'px';
      menu.style.width=width+'px';
    }
    filterDetails.forEach(detail=>{
      detail.addEventListener('toggle',()=>{
        if(!detail.open)return;
        filterDetails.forEach(other=>{if(other!==detail)other.open=false});
        positionFilter(detail);
      });
    });
    document.addEventListener('pointerdown',event=>{
      filterDetails.forEach(detail=>{if(detail.open&&!detail.contains(event.target))detail.open=false});
    });
    window.addEventListener('resize',()=>{
      filterDetails.forEach(detail=>{if(detail.open)positionFilter(detail)});
    },{passive:true});
    window.addEventListener('scroll',()=>{
      filterDetails.forEach(detail=>{if(detail.open)detail.open=false});
    },{passive:true});

    const rail=root.querySelector('[data-rail]');
    root.querySelectorAll('[data-slide]').forEach(b=>b.addEventListener('click',()=>{
      if(!rail)return;
      let card=rail.querySelector('.alc-shop__card');
      let step=(card?card.getBoundingClientRect().width:230)+15;
      rail.scrollBy({left:step*Number(b.dataset.slide)*2,behavior:'smooth'});
    }));
    let toastTimer=0;
    function toast(message){
      const el=root.querySelector('[data-toast]'); if(!el)return;
      el.textContent=message;el.hidden=false;clearTimeout(toastTimer);
      toastTimer=setTimeout(()=>{el.hidden=true;},4000);
    }
    function updateCart(cart){
      window.AlcBasketSync?.render(cart);
    }

    root.addEventListener('submit',async e=>{
      const form=e.target.closest('[data-alc-add]');if(!form||!root.contains(form))return;
      e.preventDefault();
      const btn=form.querySelector('button[type="submit"]');
      if(btn.disabled)return;
      btn.disabled=true;btn.setAttribute('aria-busy','true');
      const oldText=btn.textContent;btn.textContent='ADDING…';
      try{
        const fd=new FormData(form);
        const drawer=document.querySelector('cart-drawer');
        if(drawer){fd.append('sections','cart-drawer,cart-icon-bubble');fd.append('sections_url',window.location.pathname);}
        const res=await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root+'cart/add.js' : '/cart/add.js',{
          method:'POST',body:fd,headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}});
        const data=await res.json();
        if(!res.ok)throw Error(data.description||data.message||'Unable to add item');
        const c=await fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(x=>x.json());
        updateCart(c);
        window.AlcBasketSync?.render(c);
        if(drawer && data.sections && data.sections['cart-drawer'] && typeof drawer.renderContents==='function'){
          try{drawer.renderContents(data);}catch(err){toast('Added to cart. Open your bag to review.');}
        }else{toast('Added to cart ✓  ·  Open the bag to review');}
        btn.textContent='ADDED ✓';
        setTimeout(()=>{if(btn.isConnected)btn.textContent=oldText;},1300);
      }catch(err){toast(err.message||'Could not add this item');btn.textContent=oldText;}
      finally{btn.disabled=false;btn.removeAttribute('aria-busy');}
    });
    fetch('/cart.js').then(r=>r.ok?r.json():null).then(c=>{if(c)updateCart(c);}).catch(()=>{});
  }
  function start(){document.querySelectorAll('[data-alc-shop]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();

/* Seamless product batches on a single continuous collection page. */
(function(){
  function initPage(root){
    if(root.dataset.alcInfiniteReady==='1')return;
    root.dataset.alcInfiniteReady='1';
    const control=root.querySelector('[data-alc-all-products]');
    const cue=root.querySelector('[data-alc-downcue]');
    function updateCue(){
      if(!cue||!control)return;
      const more=control.getBoundingClientRect().top>window.innerHeight-45;
      cue.classList.toggle('is-visible',more);
    }
    updateCue();
    window.addEventListener('resize',updateCue,{passive:true});
    window.addEventListener('scroll',updateCue,{passive:true});
    const grid=root.querySelector('.alc-shop__grid');
    if(!grid)return;
    let moreEl=root.querySelector('[data-alc-more]'),loading=false,observer=null;
    async function appendBatch(){
      if(!moreEl||loading)return;
      const url=moreEl.getAttribute('data-next-url');
      if(!url)return;
      loading=true;
      try{
        const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'}});
        if(!response.ok)throw Error('Unable to load more products');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const nextRoot=doc.querySelector('[data-alc-shop]');
        const nextGrid=nextRoot?.querySelector('.alc-shop__grid');
        if(!nextGrid)throw Error('More products could not be loaded');
        const cards=Array.from(nextGrid.querySelectorAll('.alc-shop__card'));
        if(!cards.length)throw Error('No further products found');
        cards.forEach(card=>grid.appendChild(document.importNode(card,true)));
        const nextMore=nextRoot.querySelector('[data-alc-more]');
        if(nextMore?.dataset.nextUrl){
          moreEl.dataset.nextUrl=nextMore.dataset.nextUrl;
          moreEl.classList.remove('is-error');
        }else{
          observer?.unobserve(moreEl);
          moreEl.remove();
          moreEl=null;
        }
      }catch(error){
        if(moreEl){
          moreEl.classList.add('is-error');
          moreEl.removeAttribute('data-next-url');
          moreEl.innerHTML='<button type="button" data-alc-retry-more>LOAD MORE PRODUCTS</button>';
          moreEl.querySelector('button')?.addEventListener('click',()=>{
            moreEl.dataset.nextUrl=url;
            moreEl.classList.remove('is-error');
            moreEl.textContent='LOADING MORE PRODUCTS…';
            appendBatch();
          },{once:true});
        }
      }finally{loading=false}
    }
    if(moreEl){
      if('IntersectionObserver' in window){
        observer=new IntersectionObserver(entries=>{
          if(entries.some(entry=>entry.isIntersecting))appendBatch();
        },{rootMargin:'700px 0px'});
        observer.observe(moreEl);
      }else{
        moreEl.innerHTML='<button type="button" data-alc-retry-more>LOAD MORE PRODUCTS</button>';
        moreEl.querySelector('button')?.addEventListener('click',()=>{
          moreEl.textContent='LOADING MORE PRODUCTS…';
          appendBatch();
        });
      }
    }
  }
  function boot(){document.querySelectorAll('[data-alc-shop]').forEach(initPage)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
